import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const DotnetColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M15 1H1V15H15V1Z" fill="#512BD4" />
    <path
      d="M3.49525 9.94443C3.39626 9.94443 3.31212 9.91146 3.24282 9.84548C3.17353 9.77782 3.13888 9.69747 3.13888 9.60444C3.13888 9.5097 3.17353 9.42852 3.24282 9.36086C3.31212 9.29319 3.39626 9.25936 3.49525 9.25936C3.59589 9.25936 3.68086 9.29319 3.75015 9.36086C3.82109 9.42852 3.85656 9.5097 3.85656 9.60444C3.85656 9.69747 3.82109 9.77782 3.75015 9.84548C3.68086 9.91146 3.59589 9.94443 3.49525 9.94443Z"
      fill="white"
    />
    <path
      d="M7.4525 9.88862H6.80905L5.11385 7.21422C5.07096 7.14655 5.03547 7.07634 5.00744 7.00361H4.99258C5.00578 7.08143 5.01238 7.24805 5.01238 7.50346V9.88862H4.44317V6.25H5.12868L6.76699 8.86097C6.83628 8.96925 6.88083 9.04368 6.90063 9.08426H6.91052C6.89403 8.98786 6.88577 8.82462 6.88577 8.59454V6.25H7.4525V9.88862Z"
      fill="white"
    />
    <path
      d="M10.2243 9.88862H8.23214V6.25H10.1451V6.76257H8.82115V7.79273H10.0412V8.30275H8.82115V9.3786H10.2243V9.88862Z"
      fill="white"
    />
    <path d="M13.0556 6.76257H12.036V9.88862H11.4469V6.76257H10.4298V6.25H13.0556V6.76257Z" fill="white" />
  </Icon>
));

export default DotnetColor;
